var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zoom - Button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Back",
    y: 18,
    width: 18,
    height: 18,
    transform: "rotate(-90 0 18)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.84375,
    y: 8.0625,
    width: 10.0861,
    height: 2.12652,
    fill: "#3D8DD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/ZoomOutIcon.b5852b7f51ee15ddb60ebdbe44e1745a.svg";
export { ForwardRef as ReactComponent };